export enum CustomMaskRegex {
  A = <any>'[0-9a-zA-Z]',
  S = <any>'[a-zA-Z]',
  Z = <any>'[0-9]',
}

export enum CustomDateMask {
  DD_MM_YYYY = <any>'DD/MM/YYYY',
}
export enum DateMaskFunction {
  D = <any>'D',
  M = <any>'M',
  Y = <any>'Y',
  NO_FN = <any>'_',
}
